<template>
  <v-container fluid class="px-0">
    <h3 ref="detailObjektas" class="mt-3 mb-5">{{ turtasTitle }}</h3>
    <div v-if="pageloading" class="text-center my-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-if="showSearch">
      <template v-if="showFail">
        <v-col cols="12">
          <v-alert dense outlined type="error">
            {{ failMsg }}
          </v-alert>
        </v-col>
      </template>
      <template v-if="isNtr">
        <turtas-ntr-search :turtas-role="turtasRole" @cancelData="cancelData" />
      </template>
      <template v-if="!isNtr">
        <form
          @keydown.enter.prevent="searchTurtas()"
          @keydown.esc.prevent="cancelData()"
        >
          <v-row align="baseline" class="mb-4">
            <template v-if="turtasRole">
              <v-col cols="12" md="3" v-if="search0 !== null">
                <el-autocomplete
                  :items="search0Items"
                  itemvalue="value"
                  itemtext="text"
                  :label="search0"
                  :tooltip="search0Tooltip"
                  :readonly="isSearching"
                  autoSelectFirst
                  v-model="formData[search0Field]"
                />
              </v-col>
              <v-col
                cols="12"
                :md="showPrideti ? 3 : 4"
                v-if="search1 !== null"
              >
                <el-text-field
                  :label="search1"
                  :tooltip="search1Tooltip"
                  :readonly="isSearching"
                  v-mask="mask1"
                  :placeholder="placeholder1"
                  v-model="formData.tur_identifikatorius"
                  autofocus
                />
              </v-col>
              <v-col
                cols="12"
                :md="showPrideti ? 2 : 4"
                v-if="search2 !== null"
              >
                <el-text-field
                  :label="search2"
                  :tooltip="search2Tooltip"
                  :readonly="isSearching"
                  v-model="formData[search2Field]"
                />
              </v-col>
              <v-col cols="12" md="4" v-if="search3 !== null">
                <el-text-field
                  :label="search3"
                  :tooltip="search3Tooltip"
                  :readonly="isSearching"
                  v-model="formData[search3Field]"
                />
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" md="6">
                <el-role-negalima />
              </v-col>
            </template>
            <v-col cols="12" :md="showPrideti ? 4 : 4">
              <el-button
                v-if="turtasRole"
                primary
                @click.native="searchTurtas()"
                :loading="loadingSearch"
                :disabled="isSearching"
                >{{ searchTitle }}</el-button
              >
              <el-button
                v-if="showPrideti"
                primary
                @click.native="pridetiTurtas()"
                :loading="loadingSearch"
                :disabled="disabledPrideti"
                >Pridėti naują</el-button
              >
              <el-button @click.native="cancelData()" :loading="loadingSearch"
                >Atšaukti</el-button
              >
            </v-col>
          </v-row>
        </form>
        <template v-if="isSearching">
          <el-turtas-loading :loading="true" />
        </template>
      </template>
    </template>
    <template v-if="showData">
      <component
        :is="turtasInfoComponent"
        :key="turtasComponentKey"
        :form-data="formData"
        :readonly="turtasReadonly && !isAntstolisPakeitimasNtr"
        :sudarymas="isSudarymas || isNaujas"
        :irasomas="turtasIrasomas"
      ></component>

      <v-row class="mb-4">
        <v-col cols="12" md="12">
          <el-textarea
            :need="needAprasymas"
            label="Aprašymas"
            tooltip="Hipoteka. Turtas. Aprašymas"
            counter="3000"
            :readonly="turtasReadonly && !isAntstolisPakeitimas"
            v-model="formData.tur_aprasymas"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-money-field
            label="Vertė, EUR"
            tooltip="Hipoteka. Turtas. Vertė"
            :readonly="turtasReadonly"
            v-model="formData.tur_verte"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-textarea
            label="Nustatyta"
            tooltip="Hipoteka. Turtas. Nustatyta"
            counter="1000"
            :readonly="turtasReadonly"
            v-model="formData.tur_nustatyta"
          />
        </v-col>
      </v-row>

      <v-card>
        <v-card-title class="mb-0 pb-0">
          <h4>
            <p class="text-inline mb-0">
              {{ turtasDavejasTitle
              }}<el-tooltip v-if="isNtr" :tooltip="turtasDavejasTooltip" />
            </p>
          </h4>
        </v-card-title>
        <v-card-text>
          <template v-if="isNtr">
            <turtas-ntr-davejas
              :asmuo-role="davejas"
              :turtas-dalys="formData.turtas_dalys"
              :turtine-teise="turtineTeise"
              :antstolis-pakeitimas="isAntstolisPakeitimasNtr"
              :readonly="turtasReadonly && !isAdresas"
              @updateTurtasDalys="updateTurtasDalys"
            />
            <el-checkbox
              v-if="showBusimasSavininkasSwtch"
              label="Būsimas savininkas (-ai)"
              tooltip="Hipoteka. Turtas. Būsimas savininkas"
              :readonly="busimasSavininkasCheckReadonly"
              v-model="formData.tur_busimi_savininkai"
            />
            <hipoteka-asmenys
              v-if="isBusimasSavininkas"
              :asmuo-role="busimas_savininkas"
              :turtas="true"
              :readonly="turtasReadonly && !isAdresas"
              @updateBusimasSavininkas="updateBusimasSavininkas"
            />
          </template>
          <template v-if="!isNtr">
            <hipoteka-asmenys
              :asmuo-role="davejas"
              :turtas-davejas="formData.turtas_davejas"
              :turtas="true"
              :ntr="isNtr"
              :ktp="isKtp"
              :readonly="turtasReadonly && !isAdresas"
              @updateTurtasDavejas="updateTurtasDavejas"
            />
          </template>
        </v-card-text>
      </v-card>
      <v-card class="mt-4" v-if="showTurtasGavejas">
        <v-card-title class="mb-0 pb-0">
          <h4>{{ turtasGavejasTitle }}</h4>
        </v-card-title>
        <v-card-text>
          <hipoteka-asmenys
            :asmuo-role="gavejas"
            :turtas="true"
            :readonly="turtasReadonly && !isAdresas"
          />
        </v-card-text>
      </v-card>

      <v-footer class="form-footer mt-3">
        <el-button
          v-if="!turtasReadonly || isAntstolisPakeitimas"
          primary
          @click.native="saveData(null, 'close')"
          :loading="loading"
          >Saugoti</el-button
        >
        <el-button @click.native="cancelData()" :loading="loading"
          >Atšaukti</el-button
        >
        <v-spacer></v-spacer>
        <el-button
          v-if="showReloadTurtas && !turtasReadonly"
          @click.native="reloadTurtas()"
          :loading="loading"
          >Atnaujinti duomenis iš registro</el-button
        >
        <el-button
          v-if="!turtasReadonly"
          primary
          @click.native="checkErrorsClick()"
          :loading="loading"
          >Tikrinti</el-button
        >
      </v-footer>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import turtasLoadStatus from '../../../mixins/turtasLoadStatus'
import userRole from '../../../mixins/userRole'
import HipotekaMap from './../hipotekaMap'
import HipotekaAsmenys from '../HipotekaAsmenys'
import unsavedData from '../../../mixins/unsavedData'
import checkErrors from '../../../mixins/checkErrors'
import busena from '../../../mixins/busena'

import TurtasKTP from './TurtasKTP'
import TurtasGinklas from './TurtasGinklas'
import TurtasJuruLaivas from './TurtasJuruLaivas'
import TurtasLaivelis from './TurtasLaivelis'
import TurtasTraktorius from './TurtasTraktorius'
import TurtasOrlaivis from './TurtasOrlaivis'
import TurtasVagonas from './TurtasVagonas'
import TurtasPrekesZenklas from './TurtasPrekesZenklas'
import TurtasKitas from './TurtasKitas'
import TurtasDizainas from './TurtasDizainas'
import TurtasPatentas from './TurtasPatentas'
import TurtasImone from './TurtasImone'
import TurtasBankoSaskaita from './TurtasBankoSaskaita'
import TurtasNtr from './TurtasNtr'
import TurtasBusimasNtr from './TurtasBusimasNtr'
import TurtasKitasNtr from './TurtasKitasNtr'
import TurtasNtrSearch from './TurtasNtrSearch'
import TurtasNtrDavejas from './TurtasNtrDavejas'

export default {
  name: 'TurtasObjektas',
  components: {
    HipotekaAsmenys,
    TurtasNtrSearch,
    TurtasNtrDavejas,
  },
  mixins: [turtasLoadStatus, userRole, unsavedData, checkErrors, busena],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    readonly: Boolean,
  },
  data() {
    return {
      formData: {
        tur_id: null,
        tur_rusis: null,
        tur_identifikatorius: null,
        tur_loaded: false,
        tur_load_status: null,
        tur_verte: 0,
        tur_aprasymas: '',
        tur_nustatyta: '',
      },
      ntrSearchRefresh: 0,
      loading: true,
      loadingSearch: false,
      refreshTimer: null,
      busimasSavininkasCount: 1,
      customFailMsg: null,
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'objektasSalyginis',
      'turtasID',
      'turtasRusis',
      'appSavitarna',
      'perduodamasKreditoriui',
    ]),
    turtasInfoList() {
      return {
        orlaivis: {
          component: TurtasOrlaivis,
          search1: 'Identifikavimo kodas',
          search1Tooltip: 'Hipoteka. Turtas. Orlaivis. Identifikavimo kodas',
          searchType: 'edit',
          gavejas: true,
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        vagonas: {
          component: TurtasVagonas,
          search1: 'Identifikacijos numeris',
          search1Tooltip: 'Hipoteka. Turtas. Riedmuo. Identifikacijos numeris',
          searchType: 'edit',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        prekes_zenklas: {
          component: TurtasPrekesZenklas,
          search0: 'Apimtis',
          search0Tooltip: 'Hipoteka. Turtas. Prekės ženklas. Apimtis. Paieškai',
          search0Field: 'tur_vpb_apimtis',
          search0Items: this.turtasVpbApimtis,
          search1: 'Ženklo registracijos numeris',
          search1Tooltip:
            'Hipoteka. Turtas. Prekės ženklas. Ženklo registracijos numeris',
          search2: 'Paraiškos numeris',
          search2Tooltip:
            'Hipoteka. Turtas. Prekės ženklas. Paraiškos numeris. Paieškai',
          search2Field: 'tur_vpb_paraiska',
          searchType: 'search',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        kitas: {
          component: TurtasKitas,
          searchType: 'edit',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        dizainas: {
          component: TurtasDizainas,
          search0: 'Apimtis',
          search0Tooltip: 'Hipoteka. Turtas. Dizainas. Apimtis. Paieškai',
          search0Field: 'tur_vpb_apimtis',
          search0Items: this.turtasVpbApimtis,
          search1: 'Dizaino registracijos numeris',
          search1Tooltip:
            'Hipoteka. Turtas. Dizainas. Dizaino registracijos numeris',
          search2: 'Paraiškos numeris',
          search2Tooltip:
            'Hipoteka. Turtas. Dizainas. Paraiškos numeris. Paieškai',
          search2Field: 'tur_vpb_paraiska',
          searchType: 'search',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        patentas: {
          component: TurtasPatentas,
          search1: 'Patento registracijos numeris',
          search1Tooltip:
            'Hipoteka. Turtas. Patentas. Patento registracijos numeris',
          searchType: 'edit',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        banko_saskaita: {
          component: TurtasBankoSaskaita,
          search1: 'Sąskaitos numeris',
          search1Tooltip: 'Hipoteka. Turtas. Banko sąskaita. Sąskaitos numeris',
          searchType: 'edit',
          mask1: 'AA## ##### ###########',
          placeholder1: 'LT## ##### ###########',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        ktp: {
          component: TurtasKTP,
          search1: 'Identifikavimo numeris suteiktas gamintojo (VIN kodas)',
          search1Tooltip:
            'Hipoteka. Turtas. Transporto priemonė. Identifikavimo numeris. Paieškai',
          search2: 'Valstybinis numeris',
          search2Tooltip:
            'Hipoteka. Turtas. Transporto priemonė. Valstybinis numeris. Paieškai',
          search2Field: 'tur_ktp_valstybinis_numeris',
          searchType: 'search',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        imone: {
          component: TurtasImone,
          search1: 'Juridinio asmens kodas',
          search1Tooltip:
            'Hipoteka. Turtas. Įmonė. Juridinio asmens kodas. Paieškai',
          searchType: 'search',
          gavejas: false,
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        ginklas: {
          component: TurtasGinklas,
          search1: 'Identifikavimo kodas',
          search1Tooltip:
            'Hipoteka. Turtas. Ginklas. Identifikavimo kodas. Paieškai',
          search2: 'Ginklo numeris',
          search2Tooltip: 'Hipoteka. Turtas. Ginklas. Ginklo numeris. Paieškai',
          search2Field: 'tur_ginklas_numeris',
          searchType: 'search',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        juru_laivas: {
          component: TurtasJuruLaivas,
          search1: 'Identifikavimo kodas',
          search1Tooltip:
            'Hipoteka. Turtas. Jūrų laivas. Identifikavimo kodas. Paieškai',
          search2: 'Registracijos numeris',
          search2Tooltip:
            'Hipoteka. Turtas. Jūrų laivas. Registracijos numeris. Paieškai',
          search2Field: 'tur_juru_laivas_registracijos_numeris',
          searchType: 'search',
          gavejas: true,
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        laivelis: {
          component: TurtasLaivelis,
          search1: 'Identifikavimo kodas',
          search1Tooltip:
            'Hipoteka. Turtas. Vidaus vandenų transportas. Identifikavimo kodas. Paieškai',
          search2: 'Registro (identifikavimo) numeris',
          search2Tooltip:
            'Hipoteka. Turtas. Vidaus vandenų transportas. Registracijos numeris. Paieškai',
          search2Field: 'tur_laivelis_registracijos_numeris',
          searchType: 'search',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        traktorius: {
          component: TurtasTraktorius,
          search1: 'Unikalus atpažinties kodas',
          search1Tooltip:
            'Hipoteka. Turtas. Traktorius. Unikalus atpažinties kodas. Paieškai',
          searchType: 'search',
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        ntr: {
          component: TurtasNtr,
          searchType: 'search',
          gavejas: false,
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        busimas_ntr: {
          component: TurtasBusimasNtr,
          search1: 'Statybos leidimo numeris',
          search1Tooltip:
            'Hipoteka. Turtas. Būsimas NTR. Statybos leidimo numeris',
          searchType: 'edit',
          gavejas: false,
          role: this.roleDT || this.roleRG || this.roleEL,
        },
        kita_turtine_teise: {
          component: TurtasKitasNtr,
          searchType: 'edit',
          gavejas: true,
          role: this.roleDT || this.roleRG || this.roleEL,
        },
      }
    },
    pageloading() {
      return !this.showSearch && !this.showData
    },
    turtasReadonly() {
      return this.readonly || this.loadStatusPasikeite
    },
    isAntstolis() {
      return this.role(['DT_antstolis'])
    },
    isPakeitimas() {
      return this.hipotekaTipas.includes('pakeitimas')
    },
    isAntstolisPakeitimas() {
      return (
        this.isPakeitimas &&
        this.isAntstolis &&
        (this.isRengiamas || this.isGrazintas)
      )
    },
    isAntstolisPakeitimasNtr() {
      return this.isAntstolisPakeitimas && this.isNtr
    },
    turtasTitle() {
      return HipotekaMap['turtasTipas'][this.turtasRusis].title
    },
    turtasInfo() {
      return this.turtasInfoList[this.turtasRusis] ?? { component: null }
    },
    turtasInfoComponent() {
      return typeof this.turtasInfo.component === 'string'
        ? null
        : this.turtasInfo.component
    },
    turtasRole() {
      return this.turtasInfo.role
    },
    turLoadStatus() {
      return this.formData.tur_load_status
    },
    search1() {
      return this.turtasInfo.search1 ?? null
    },
    search1Tooltip() {
      return this.turtasInfo.search1Tooltip ?? null
    },
    search2Tooltip() {
      return this.turtasInfo.search2Tooltip ?? null
    },
    search3Tooltip() {
      return this.turtasInfo.search3Tooltip ?? null
    },
    search0Tooltip() {
      return this.turtasInfo.search0Tooltip ?? null
    },
    mask1() {
      return this.turtasInfo.mask1 ?? null
    },
    placeholder1() {
      return this.turtasInfo.placeholder1 ?? ' '
    },
    search2() {
      return this.turtasInfo.search2 ?? null
    },
    search2Field() {
      return this.turtasInfo.search2Field ?? null
    },
    search3() {
      return this.turtasInfo.search3 ?? null
    },
    search3Field() {
      return this.turtasInfo.search3Field ?? null
    },
    search0() {
      return this.turtasInfo.search0 ?? null
    },
    search0Field() {
      return this.turtasInfo.search0Field ?? null
    },
    search0Items() {
      return this.turtasInfo.search0Items ?? null
    },
    isTurtasSearch() {
      return this.turtasInfo.searchType === 'search'
    },
    isTurtasEdit() {
      return this.turtasInfo.searchType === 'edit'
    },
    searchTitle() {
      if (this.isTurtasSearch) {
        return 'Ieškoti registre'
      } else if (this.isTurtasEdit) {
        return 'Tęsti'
      } else {
        return 'Tęsti'
      }
    },
    showSearch() {
      return (
        !(this.loadStatusGauta || this.loadStatusPasikeite) &&
        this.formData.tur_id !== null
      )
    },
    failMsg() {
      if (this.customFailMsg) {
        return this.customFailMsg
      }
      if (this.loadStatusNutraukta) {
        if (this.isVpb) {
          return 'Duomenų užkrovimas iš Lietuvos Respublikos valstybinio patentų registro negalimas, nes nėra ryšio su registru. Bandykite vėliau.'
        }
        if (this.isGinklas) {
          return 'Duomenų užkrovimas iš Ginklų registru negalimas, nes nėra ryšio su registru. Bandykite vėliau.'
        }
        if (this.isTraktorius) {
          return 'Duomenų užkrovimas iš Traktorių registro negalimas, nes nėra ryšio su registru. Bandykite vėliau.'
        }
        if (this.isLaivelis || this.isJuruLaivas) {
          return 'Duomenų užkrovimas iš Laivų registro negalimas, nes nėra ryšio su registru. Bandykite vėliau.'
        }
        return 'Registro klaida. Bandykite dar kartą'
      }

      if (this.loadStatusNesutampa) {
        return 'Turto savininkas nesutampa su įkaito davėju'
      }

      if (this.isGinklas) {
        return 'Duomenų pagal įvestus paieškos parametrus nerasta. Pasitikrinkite paieškos parametrus.'
      }
      if (this.isVpb) {
        return 'Duomenų pagal įvestus paieškos parametrus nerasta. Pasitikrinkite paieškos parametrus.'
      }
      if (this.isTraktorius) {
        return 'Duomenų pagal įvestus paieškos parametrus nerasta. Pasitikrinkite paieškos parametrus.'
      }
      if (this.isLaivelis || this.isJuruLaivas) {
        return 'Duomenų pagal įvestus paieškos parametrus nerasta. Pasitikrinkite paieškos parametrus.'
      }
      return 'Turtas nerastas'
    },
    showFail() {
      return (
        this.loadStatusNerasta ||
        this.loadStatusNutraukta ||
        this.loadStatusNesutampa ||
        this.customFailMsg
      )
    },
    showData() {
      return (
        this.formData.tur_loaded &&
        (this.loadStatusGauta || this.loadStatusPasikeite)
      )
    },
    isSearching() {
      return this.loadStatusNepradeta || this.loadStatusPaleista
    },
    isNaujas() {
      return this.formData.new
    },
    isKitas() {
      return this.turtasRusis === 'kitas'
    },
    isKitasNtr() {
      return this.turtasRusis === 'kita_turtine_teise'
    },
    isBusimasNtr() {
      return this.turtasRusis === 'busimas_ntr'
    },
    isNtr() {
      return this.turtasRusis === 'ntr'
    },
    isKtp() {
      return this.turtasRusis === 'ktp'
    },
    isGinklas() {
      return this.turtasRusis === 'ginklas'
    },
    isTraktorius() {
      return this.turtasRusis === 'traktorius'
    },
    isLaivelis() {
      return this.turtasRusis === 'laivelis'
    },
    isJuruLaivas() {
      return this.turtasRusis === 'juru_laivas'
    },
    isVpb() {
      return (
        this.turtasRusis === 'dizainas' || this.turtasRusis === 'prekes_zenklas'
      )
    },
    needAprasymas() {
      return this.isKitas || this.isKitasNtr || this.isBusimasNtr
    },
    loadingData() {
      return !this.formData.tur_loaded
    },
    turtasTipasKey() {
      return Object.keys(HipotekaMap['turtasTipas']).find(
        rusis =>
          HipotekaMap['turtasTipas'][rusis].tur_rusis ===
          this.formData.tur_rusis
      )
    },
    turtasComponentKey() {
      return 'turtas_objektas' + this.formData.tur_id
    },
    refreshTimeout() {
      return this.turtasRusis
        ? HipotekaMap['turtasTipas'][this.turtasRusis].refresh
        : 1000
    },
    davejas() {
      return HipotekaMap['asmenysRoles'].turtas_davejas
    },
    busimas_savininkas() {
      return HipotekaMap['asmenysRoles'].busimas_savininkas
    },
    isBusimasSavininkas() {
      return (
        this.formData.tur_busimi_savininkai || this.busimasSavininkasCount > 0
      )
    },
    showBusimasSavininkasSwtch() {
      return this.objektasSalyginis
    },
    busimasSavininkasCheckReadonly() {
      return this.turtasReadonly && !this.isAdresas
    },
    gavejas() {
      return HipotekaMap['asmenysRoles'].turtas_gavejas
    },
    showTurtasGavejas() {
      return (
        this.turtasInfo.gavejas != false &&
        (!this.isSavitarna || this.perduodamasKreditoriui !== 0)
      )
    },
    isSavitarna() {
      return this.appSavitarna
    },
    showReloadTurtas() {
      return this.formData.irasomas === false
    },
    isPriverstinis() {
      return this.hipotekaTipas.includes('priverstinis')
    },
    isAdresas() {
      return (
        this.hipotekaTipas.includes('adresas') &&
        (this.isRengiamas || this.isGrazintas)
      )
    },
    turtasDavejasTitle() {
      return this.isPriverstinis
        ? 'Turto savininkas(-ai)'
        : 'Įkaito davėjas(-ai)'
    },
    turtasDavejasTooltip() {
      return this.isPriverstinis
        ? 'Hipoteka. Turtas. NTR. Turto savininkas'
        : 'Hipoteka. Turtas. NTR. Įkaito davėjas'
    },
    isHipoteka() {
      return this.hipotekaTipas.includes('hipoteka')
    },
    isSudarymas() {
      return (
        this.hipotekaTipas.includes('sandoris') ||
        this.hipotekaTipas.includes('nustatymas')
      )
    },
    turtasGavejasTitle() {
      return this.isHipoteka
        ? 'Asmenys, kuriems perduotas hipotekos objektas'
        : 'Asmenys, kuriems perduotas įkeitimo objektas'
    },
    turtasIrasomas() {
      return this.formData.irasomas
    },
    turtineTeise() {
      return this.formData.tur_ntr_teit_tipas !== 1
    },
    turtasVpbApimtis() {
      return [
        { value: 'LT', text: 'Nacionalinė registracija' },
        { value: 'EM', text: 'Europinė registracija' },
        { value: 'WO', text: 'Tarptautinė registracija' },
      ]
    },
    showPrideti() {
      return this.turtasRole && this.isVpb
    },
    disabledPrideti() {
      return this.isSearching || !this.formData.tur_id
    },
  },
  created() {
    this.$store.dispatch('turtasID', this.$route.params.turtasID)
    this.$store.dispatch('turtasRusis', this.$route.params.turtasRusis)
    this.getData(true)
  },
  mounted() {},
  methods: {
    pridetiTurtas() {
      this.searchTurtas(true)
    },

    searchTurtas(forceIrasomas = false) {
      this.loadingSearch = true
      this.customFailMsg = null
      const data = {
        obj_id: this.objektasID,
        tur_id: this.formData.tur_id,
        tipas: this.turtasRusis,
        force_irasomas: forceIrasomas,
        tur_identifikatorius: this.formData.tur_identifikatorius,
        [this.search2Field]: this.formData[this.search2Field],
        [this.search3Field]: this.formData[this.search3Field],
        [this.search0Field]: this.formData[this.search0Field],
      }
      if (!this.validateSearch() && !forceIrasomas) {
        window._VMA.$emit('DATA_ERROR', 'Įveskite paieškos parametrus')
        this.loadingSearch = false
        return
      }
      this.$axios
        .post(`objektas/${this.objektasID}/turtas/search`, data)
        .then(res => {
          this.formData = res.data.turtas
          if (this.isKtp) {
            window._VMA.$emit('DATA_OK', res.data.message)
          }
          this.$store
            .dispatch('turtasID', this.formData.tur_id)
            .then(this.getData())
        })
        .catch(err => {
          if (this.isKtp) {
            this.customFailMsg = err.response.data.message
            return
          }
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadingSearch = false
        })
    },
    validateSearch() {
      if (this.isTurtasEdit) {
        return true
      }
      if (this.isKitas || this.isKitasNtr) {
        return true
      }
      if (
        this.formData.tur_identifikatorius &&
        this.formData.tur_identifikatorius.length > 0
      ) {
        return true
      }
      if (
        this.formData[this.search2Field] &&
        this.formData[this.search2Field].length > 0
      ) {
        return true
      }
      if (
        this.formData[this.search3Field] &&
        this.formData[this.search3Field].length > 0
      ) {
        return true
      }
      return false
    },
    checkLoading() {
      if (this.loadingData) {
        if (!this.refreshTimer && this.refreshTimeout > 0) {
          this.refreshTimer = setInterval(() => {
            if (this.refreshTimer) {
              this.getData(true)
            }
          }, this.refreshTimeout)
        }
      } else {
        this.stopLoading()

        if (this.$route.params.turtasID === 0) {
          this.$router.push({
            name: 'turtasObjektas',
            params: {
              turtasID: this.formData.tur_id,
              turtasRusis: this.formData.tur_rusis,
            },
          })
        }
      }
    },
    stopLoading() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    },
    getData(firstLoad = false) {
      if (this.turtasID > 0) {
        this.loading = true
        this.$axios
          .get(
            `objektas/${this.objektasID}/turtas/${this.turtasID}/${this.turtasRusis}`
          )
          .then(res => {
            this.formData = res.data.turtas
            if (res.data.turtas.tur_verte) {
              this.formData.tur_verte = res.data.turtas.tur_verte
                .toString()
                .replace('.', ',')
            }
            if (this.formData.tur_banko_saskaita_lesos) {
              this.formData.tur_banko_saskaita_lesos = this.formData.tur_banko_saskaita_lesos
                .toString()
                .replace('.', ',')
            }

            if (res.data.valiutos) {
              this.formData.valiutos = res.data.valiutos
            }
            if (res.data.bankai) {
              this.formData.bankai = res.data.bankai
            }
            if (res.data.ntr_rusys) {
              this.formData.ntr_rusys = res.data.ntr_rusys
            }
            if (!this.turtasReadonly) {
              this.initialForm()
            }
            this.checkLoading()
          })
          .catch(err => {
            this.cancelData()
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {
            this.loading = false
            if (firstLoad) {
              this.$nextTick(() => {
                if (this.$refs.detailObjektas) {
                  this.$vuetify.goTo(this.$refs.detailObjektas)
                }
              })
            }
            this.$root.$emit('updateTurtasList')
          })
      } else {
        this.formData.tur_id = 0
        if (this.isTurtasEdit) {
          this.searchTurtas()
        }
      }
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.stopLoading()
          this.loading = true
          this.fixMoneyField()

          let data = this.formData
          delete data.bankai
          delete data.valiutos
          data.obj_id = this.objektasID

          this.$axios
            .post(
              `objektas/${this.objektasID}/turtas/${this.turtasID}/${this.turtasRusis}`,
              data
            )
            .then(res => {
              this.$root.$emit('updateTurtasList')
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')

              if (toRoute) {
                this.goToRoute()
              } else {
                if (!this.turtasReadonly) {
                  this.initialForm()
                }
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
                if (afterSave === 'close') {
                  this.closeTurtas()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    fixMoneyField() {
      if (this.formData.tur_verte) {
        this.formData.tur_verte = this.formData.tur_verte
          .toString()
          .replace(',', '.')
      }
      if (this.formData.tur_banko_saskaita_lesos) {
        this.formData.tur_banko_saskaita_lesos = this.formData.tur_banko_saskaita_lesos
          .toString()
          .replace(',', '.')
      }
    },
    cancelData() {
      this.stopLoading()
      this.$store.dispatch('unsavedData', false).then(() => {
        this.closeTurtas()
      })
    },
    closeTurtas() {
      this.$emit('closeTurtas')
    },
    updateTurtasDavejas(list) {
      this.formData.turtas_davejas = list
    },
    updateTurtasDalys(list) {
      this.formData.turtas_dalys = list
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
    reloadTurtas() {
      this.loading = true
      this.$axios
        .post(`objektas/${this.objektasID}/turtas/${this.turtasID}/reload`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateBusimasSavininkas(count) {
      this.busimasSavininkasCount = count
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
}
</script>
